<template>
  <mail-template-form :edit="edit" @saved="backToList" @cancel="backToList" />
</template>

<script>
import MailTemplateForm from '@/components/forms/MailTemplateForm';

// @vuese
// Formularz do edycji szablonów wiadomości e-mail
// @group MailTemplate
export default {
  components: { MailTemplateForm },
  props: {
    // Czy pobierać dane do formularza
    edit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    // @vuese
    // Powrót do listy widoków
    backToList() {
      this.$router.push({ name: 'mailTemplates' });
    }
  }
};
</script>
